import React from 'react'
import ComicList from './components/ComicList'

export default function App() {
  return <ComicList />
} 
